import Marquee from "react-fast-marquee";
import * as compSettings from "./settings";

const MarqueeComp = ({ id, extendedSettings }) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };
  // Settings'ten değerleri al - prop'larla override edilebilir
  const backgroundColor = settings.backgroundColor.value;
  const textColor = settings.textColor.value;
  const fontSize = settings.fontSize.value + "px";
  const fontWeight = settings.fontWeight.value;
  const paddingY = settings.paddingY.value + "px";
  const paddingX = settings.paddingX.value + "px";
  const marqueeSpeed = settings.speed.value;
  const letterSpacing = settings.letterSpacing.value + "px";
  const wordSpacing = settings.wordSpacing.value + "px";
  const repeatCount = settings.repeatCount.value;
  const direction = settings.direction.value;
  const pauseOnHover = settings.pauseOnHover.value;
  const pauseOnClick = settings.pauseOnClick.value;
  const gradient = settings.gradient.value;
  const gradientColor = settings.gradientColor.value;
  const gradientWidth = settings.gradientWidth.value + "px";
  const borderRadius = settings.borderRadius.value + "px";
  const marginY = settings.marginY.value + "px";
  const marginX = settings.marginX.value + "px";
  const textAlign = settings.textAlign.value;
  const lineHeight = settings.lineHeight.value;
  const autoFill = settings.autoFill.value;
  const play = settings.play.value;
  const delay = settings.delay.value;
  const defaultText = settings.text.value;
  const separator = settings.separator.value;

  // Metin prop'dan gelirse onu kullan, yoksa settings'ten al
  const displayText = defaultText;

  // Metni belirtilen sayıda tekrarla ve ayırıcı ile birleştir
  const repeatedText = Array(repeatCount).fill(displayText).join(separator);

  return (
    <div
      style={{
        marginTop: marginY,
        marginBottom: marginY,
        marginLeft: marginX,
        marginRight: marginX,
        borderRadius: borderRadius,
        overflow: "hidden",
      }}
    >
      <Marquee
        speed={marqueeSpeed}
        direction={direction}
        pauseOnHover={pauseOnHover}
        pauseOnClick={pauseOnClick}
        gradient={gradient}
        gradientColor={gradientColor}
        gradientWidth={gradientWidth}
        autoFill={autoFill}
        play={play}
        delay={delay}
        style={{
          backgroundColor: backgroundColor,
          color: textColor,
          fontSize: fontSize,
          fontWeight: fontWeight,
          paddingTop: paddingY,
          paddingBottom: paddingY,
          paddingLeft: paddingX,
          paddingRight: paddingX,
          letterSpacing: letterSpacing,
          wordSpacing: wordSpacing,
          textAlign: textAlign,
          lineHeight: lineHeight,
        }}
      >
        {repeatedText}
      </Marquee>
    </div>
  );
};

export default MarqueeComp;
